import { Parser } from "@siteimprove/alfa-parser";
import { Token } from "../../syntax/index.js";
import { Number } from "../numeric/index.js";
import { Format } from "./format.js";
import { RGB } from "./rgb.js";
const { map } = Parser;
/**
 * @public
 */
export class Hex extends Format {
    static of(value) {
        return new Hex(value);
    }
    _value;
    constructor(value) {
        super("hex");
        // Make sure that only the lower 4 bytes are stored.
        this._value = value & 0xff_ff_ff_ff;
    }
    get value() {
        return this._value;
    }
    get red() {
        return Number.of(this._value >>> 24);
    }
    get green() {
        return Number.of((this._value >>> 16) & 0xff);
    }
    get blue() {
        return Number.of((this._value >>> 8) & 0xff);
    }
    get alpha() {
        return Number.of(this._value & 0xff);
    }
    resolve() {
        return RGB.of(...Format.resolve(this.red, this.green, this.blue, this.alpha));
    }
    equals(value) {
        return value instanceof Hex && value._value === this._value;
    }
    hash(hash) {
        hash.writeUint32(this._value);
    }
    toJSON() {
        return {
            ...super.toJSON(),
            value: this._value,
        };
    }
    toString() {
        return `#${this._value.toString(16).padStart(8, "0")}`;
    }
}
/**
 * @public
 */
(function (Hex) {
    function isHex(value) {
        return value instanceof Hex;
    }
    Hex.isHex = isHex;
    /**
     * {@link https://drafts.csswg.org/css-color/#typedef-hex-color}
     */
    Hex.parse = map(map(Token.parseHash((hash) => {
        switch (hash.value.length) {
            case 3:
            case 4:
            case 6:
            case 8: {
                return /^[\da-f]*$/i.test(hash.value);
            }
            default:
                return false;
        }
    }), (hash) => {
        switch (hash.value.length) {
            case 3: {
                const [r, g, b] = hash.value;
                return r + r + g + g + b + b + "ff";
            }
            case 4: {
                const [r, g, b, a] = hash.value;
                return r + r + g + g + b + b + a + a;
            }
            case 6:
                return hash.value + "ff";
            default:
                return hash.value;
        }
    }), (hash) => Hex.of(parseInt(hash, 16)));
})(Hex || (Hex = {}));
//# sourceMappingURL=hex.js.map